<template>
  <div class="container information-security-wrapper">
    <div class="content">
      <p class="title">{{ pr.title }}</p>
      <div class="description">
        <p class="description-item" v-for="(item, index) in splitOnLine(pr.desc)" :key="index">{{ item }}</p>
      </div>
      <div class="safety-box" v-for="({ title, desc }, idx) in pr.list" :key="idx">
        <div
          class="safety-box-title"
          v-html="`${idx + 1}.${title}`">
        </div>
        <div class="safety-box-desc" v-html="desc"></div>
      </div>
      <p class="signature">{{ pr.signature }}</p>
    </div>
  </div>
</template>

<script>
import usePageResource from '@/composables/usePageResource';

export default {
  setup() {
    const { pr } = usePageResource('information-security');

    return {
      pr,
    };
  },
  methods: {
    splitOnLine(value) {
      return value.split('\n');
    },
  },
};
</script>

<style scoped lang="scss">
$fontColor: #303233;

.information-security-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 150px 0 160px;
  opacity: 0;
  animation: 800ms cubic-bezier(0.165, 0.84, 0.44, 1) 200ms 1 forwards slide-up-fading;

  .content {
    width: 100%;
    max-width: 900px;
    box-sizing: content-box;
    padding: 0 48px;

    .title {
      width: 100%;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      line-height: 42px;
      color: #222222;
    }

    .description {
      margin-top: 96px;
      line-height: 1.8;
      font-size: 16px;
      color: $fontColor;
      letter-spacing: 0.1em;
      &-item:not(:last-child) {
        margin-bottom: 36px;
      }
    }

    .safety-box {
      width: 100%;
      margin-top: 80px;
      color: $fontColor;
      &-title {
        margin-bottom: 28px;
        font-size: 18px;
        font-weight: bold;
        line-height: 1.5;
        letter-spacing: 0.05em;
      }
      &-desc {
        line-height: 1.8;
        letter-spacing: 0.1em;
      }
    }

    .signature {
      margin-top: 120px;
      font-size: 14px;
      color: $fontColor;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 112px 0 100px;

    .content {
      padding: 0 24px;

      .title {
        font-size: 22px;
        line-height: 1;
        line-height: 30px;
      }

      .description {
        font-size: 14px;
        line-height: 1.6;
        margin-top: 48px;
      }

      .safety-box {
        margin-top: 40px;
        &-title {
          margin-bottom: 16px;
          font-size: 15px;
          letter-spacing: 0.1em;
        }
        &-desc {
          font-size: 14px;
          letter-spacing: 0;
        }
      }

      .signature {
        margin-top: 60px;
        line-height: 24px;
      }
    }
  }
}

@keyframes slide-up-fading {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
